export enum Section {
  Dashboard = 'dashboard',
  MySkin = 'my-skin',
  ManageTestKits = 'manage-test-kits',
  Shop = 'shop',
  MyAccount = 'my-account',
  Notifications = 'notifications',
  LegalDocuments = 'legal-docs',
  Providers = 'providers',
  Appointments = 'my-appointments',
  AllAppointments = 'appointments',
  MyPatients = 'my-patients',
  ProviderAppointments = 'provider-appointments',
  Messages = 'messages',
  TestKits = 'tests',
  Patients = 'patients',
  Orders = 'orders',
  Payments = 'payments',
  Courses = 'courses',
  Admin = 'admins',
  Products = 'products',
  Calendar = 'calendar',
}
